import React, { lazy } from 'react'

const NotFoundPage = lazy(() => import('./NotFoundPage'))

export { NotFoundPage }
